import { Store } from "@/zustand/store";
import { StateCreator } from "zustand";

export type ReportParamsSlice = {
  reportFrom: Date | null;
  reportTo: Date | null;
  changeReportFrom: (reportFrom: Date) => void;
  changeReportTo: (reportTo: Date) => void;
};

const initialData = {
  reportFrom: null,
  reportTo: null,
};

export const createReportParamsSlice: StateCreator<
  Store,
  [],
  [],
  ReportParamsSlice
> = (set) => ({
  ...initialData,
  changeReportFrom: (reportFrom) => set({ reportFrom }),
  changeReportTo: (reportTo) => set({ reportTo }),
});
4;
